export const DisGraSemI = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN I"
    },
    {
        id: 1,
        nombre: "LÓGICA MATEMÁTICA"
    },
    {
        id: 3,
        nombre: "HISTORIA DEL ARTE"
    },
    {
        id: 4,
        nombre: "LENGUA Y COMUNICACIÓN"
    },
    {
        id: 5,
        nombre: "COLOR"
    },
    {
        id: 6,
        nombre: "FUNDAMENTOS DEL DISEÑO"
    }
];

export const DisGraSemII = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN II"
    },
    {
        id: 1,
        nombre: "TÉCNICAS DE ESTUDIO E INVESTIGACIÓN"
    },
    {
        id: 3,
        nombre: "HISTORIA DEL DISEÑO Y TENDENCIAS CONTEMPORÁNEAS"
    },
    {
        id: 4,
        nombre: "INGLÉS"
    },
    {
        id: 5,
        nombre: "PRINCIPIOS Y SISTEMAS DE IMPRESIÓN"
    },
    {
        id: 6,
        nombre: "RECURSOS GRÁFICOS"
    }
];

export const DisGraSemIII = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN III"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN I"
    },
    {
        id: 3,
        nombre: "SEMIÓTICA"
    },
    {
        id: 4,
        nombre: "MAQUETERÍA"
    },
    {
        id: 5,
        nombre: "TIPOGRAFÍA, ROTULACIÓN Y DIAGRAMACIÓN"
    },
    {
        id: 6,
        nombre: "TALLER DE DISEÑO GRÁFICO I"
    },
    {
        id: 7,
        nombre: "SERVICIO COMUNITARIO (INDUCCIÓN)"
    }
];

export const DisGraSemIV = [
    {
        id: 0,
        nombre: "PROCESOS DE IMPRESIÓN"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN II"
    },
    {
        id: 3,
        nombre: "PUBLICIDAD Y MERCADEO"
    },
    {
        id: 4,
        nombre: "EMPAQUES"
    },
    {
        id: 5,
        nombre: "REDACCIÓN CREATIVA"
    },
    {
        id: 6,
        nombre: "TALLER DE DISEÑO GRÁFICO II"
    },
    {
        id: 7,
        nombre: "SERVICIO COMUNITARIO (PROYECTO)"
    }
];

export const DisGraSemV = [
    {
        id: 0,
        nombre: "PSICOLOGÍA DE LA PUBLICIDAD"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN III"
    },
    {
        id: 3,
        nombre: "PUBLICACIONES WEB"
    },
    {
        id: 4,
        nombre: "TALLER DE DISEÑO GRÁFICO III"
    },
    {
        id: 5,
        nombre: "ELECTIVA"
    },
    {
        id: 6,
        nombre: "ELECTIVA"
    },
    {
        id: 7,
        nombre: "SEMINARIO DE METODOLOGÍA I"
    }
];

export const DisGraSemVI = [
    {
        id: 0,
        nombre: "ÉTICA, GERENCIA Y MARCO LEGAL"
    },
    {
        id: 1,
        nombre: "PORTAFOLIO DIGITAL"
    },
    {
        id: 3,
        nombre: "ELECTIVA"
    },
    {
        id: 4,
        nombre: "ELECTIVA"
    },
    {
        id: 5,
        nombre: "SEMINARIO DE METODOLOGÍA II"
    },
    {
        id: 6,
        nombre: "TRABAJO DE GRADO"
    }
];

export const DisGraElec = [
    {
        id: 0,
        nombre: "FOTOGRAFÍA DIGITAL"
    },
    {
        id: 1,
        nombre: "MEDIOS AUDIOVISUALES"
    },
    {
        id: 3,
        nombre: "MARKETING DIGITAL"
    },
    {
        id: 4,
        nombre: "ECODISEÑO"
    },
    {
        id: 5,
        nombre: "INFOGRAFÍA"
    },
    {
        id: 6,
        nombre: "TALLER DE EMPRENDIMIENTO"
    }
];

export const DisIntSemI = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN I"
    },
    {
        id: 1,
        nombre: "LÓGICA MATEMÁTICA"
    },
    {
        id: 3,
        nombre: "HISTORIA DEL ARTE"
    },
    {
        id: 4,
        nombre: "LENGUA Y COMUNICACIÓN"
    },
    {
        id: 5,
        nombre: "COLOR"
    },
    {
        id: 6,
        nombre: "FUNDAMENTOS DEL DISEÑO INTERIOR"
    }
];

export const DisIntSemII = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN II"
    },
    {
        id: 1,
        nombre: "TÉCNICAS DE ESTUDIO E INVESTIGACIÓN"
    },
    {
        id: 3,
        nombre: "HISTORIA DEL DISEÑO Y TENDENCIAS CONTEMPORÁNEAS"
    },
    {
        id: 4,
        nombre: "INGLÉS"
    },
    {
        id: 5,
        nombre: "TECNOLOGÍA I"
    },
    {
        id: 6,
        nombre: "DIBUJO ARQUITECTÓNICO"
    }
];

export const DisIntSemIII = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN III"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN I"
    },
    {
        id: 3,
        nombre: "ARTES DECORATIVAS Y ELEMENTOS DEL DISEÑO"
    },
    {
        id: 4,
        nombre: "MAQUETERÍA"
    },
    {
        id: 5,
        nombre: "TECNOLOGÍA II"
    },
    {
        id: 6,
        nombre: "TALLER DE DISEÑO INTERIOR I"
    },
    {
        id: 7,
        nombre: "SERVICIO COMUNITARIO (INDUCCIÓN)"
    }
];

export const DisIntSemIV = [
    {
        id: 0,
        nombre: "DISEÑO DEL MUEBLE"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN II"
    },
    {
        id: 3,
        nombre: "MERCADEO DEL DISEÑO INTERIOR"
    },
    {
        id: 4,
        nombre: "PAISAJISMO"
    },
    {
        id: 5,
        nombre: "TECNOLOGÍA III"
    },
    {
        id: 6,
        nombre: "TALLER DE DISEÑO INTERIOR II"
    },
    {
        id: 7,
        nombre: "SERVICIO COMUNITARIO (PROYECTO)"
    }
];

export const DisIntSemV = [
    {
        id: 0,
        nombre: "ESPACIOS EFÍMEROS"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN III"
    },
    {
        id: 3,
        nombre: "TECNOLOGÍA IV"
    },
    {
        id: 4,
        nombre: "TALLER DE DISEÑO INTERIOR III"
    },
    {
        id: 5,
        nombre: "ELECTIVA"
    },
    {
        id: 6,
        nombre: "ELECTIVA"
    },
    {
        id: 7,
        nombre: "SEMINARIO DE METODOLOGÍA I"
    },
    {
        id: 8,
        nombre: "PASANTÍA"
    }
];

export const DisIntSemVI = [
    {
        id: 0,
        nombre: "ÉTICA, GERENCIA Y MARCO LEGAL"
    },
    {
        id: 1,
        nombre: "PORTAFOLIO DIGITAL"
    },
    {
        id: 3,
        nombre: "ELECTIVA"
    },
    {
        id: 4,
        nombre: "ELECTIVA"
    },
    {
        id: 5,
        nombre: "SEMINARIO DE METODOLOGÍA II"
    },
    {
        id: 6,
        nombre: "TRABAJO DE GRADO"
    }
];

export const DisIntElec = [
    {
        id: 0,
        nombre: "FOTOGRAFÍA DIGITAL"
    },
    {
        id: 1,
        nombre: "PROCESOS DE IMPRESIÓN TEXTIL"
    },
    {
        id: 3,
        nombre: "INFOGRAFÍA"
    },
    {
        id: 4,
        nombre: "TALLER DE EMPRENDIMIENTO"
    },
    {
        id: 5,
        nombre: "MEDIOS AUDIOVISUALES"
    },
    {
        id: 6,
        nombre: "ECODISEÑO"
    },
    {
        id: 7,
        nombre: "ILLUSTRATOR (VECTORES)"
    },
    {
        id: 8,
        nombre: "VITRINISMO"
    }
];

export const DisModSemI = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN I"
    },
    {
        id: 1,
        nombre: "LÓGICA MATEMÁTICA"
    },
    {
        id: 3,
        nombre: "HISTORIA DEL ARTE"
    },
    {
        id: 4,
        nombre: "LENGUA Y COMUNICACIÓN"
    },
    {
        id: 5,
        nombre: "COLOR"
    },
    {
        id: 6,
        nombre: "FUNDAMENTOS DEL DISEÑO DE MODA"
    }
];

export const DisModSemII = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN II"
    },
    {
        id: 1,
        nombre: "TÉCNICAS DE ESTUDIO E INVESTIGACIÓN"
    },
    {
        id: 3,
        nombre: "HISTORIA DEL DISEÑO Y TENDENCIAS CONTEMPORÁNEAS"
    },
    {
        id: 4,
        nombre: "INGLÉS"
    },
    {
        id: 5,
        nombre: "INTRODUCCIÓN A LA CONFECCIÓN"
    },
    {
        id: 6,
        nombre: "TEXTILES"
    }
];

export const DisModSemIII = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN III"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN I"
    },
    {
        id: 3,
        nombre: "ACCESORIOS"
    },
    {
        id: 4,
        nombre: "MODELISMO"
    },
    {
        id: 5,
        nombre: "CORTE Y CONFECCIÓN I"
    },
    {
        id: 6,
        nombre: "TALLER DE DISEÑO DE MODA I"
    },
    {
        id: 7,
        nombre: "SERVICIO COMUNITARIO (INDUCCIÓN)"
    }
];

export const DisModSemIV = [
    {
        id: 0,
        nombre: "PROCESOS DE IMPRESIÓN"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN II"
    },
    {
        id: 3,
        nombre: "MERCADEO DE LA MODA"
    },
    {
        id: 4,
        nombre: "SASTRERÍA"
    },
    {
        id: 5,
        nombre: "CORTE Y CONFECCIÓN II"
    },
    {
        id: 6,
        nombre: "TALLER DE DISEÑO MODA II"
    },
    {
        id: 7,
        nombre: "SERVICIO COMUNITARIO (PROYECTO)"
    }
];

export const DisModSemV = [
    {
        id: 0,
        nombre: "DRAPEADO"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN III (PATRONAJE DIGITAL)"
    },
    {
        id: 3,
        nombre: "CORTE Y CONFECCIÓN III"
    },
    {
        id: 4,
        nombre: "TALLER DE DISEÑO DE MODA III"
    },
    {
        id: 5,
        nombre: "ELECTIVA"
    },
    {
        id: 6,
        nombre: "ELECTIVA"
    },
    {
        id: 7,
        nombre: "SEMINARIO DE METODOLOGÍA I"
    },
    {
        id: 8,
        nombre: "PASANTÍA"
    }
];

export const DisModSemVI = [
    {
        id: 0,
        nombre: "ÉTICA, GERENCIA Y MARCO LEGAL"
    },
    {
        id: 1,
        nombre: "PORTAFOLIO DIGITAL"
    },
    {
        id: 3,
        nombre: "ELECTIVA"
    },
    {
        id: 4,
        nombre: "ELECTIVA"
    },
    {
        id: 5,
        nombre: "SEMINARIO DE METODOLOGÍA II"
    },
    {
        id: 6,
        nombre: "TRABAJO DE GRADO"
    }
];

export const DisModElec = [
    {
        id: 0,
        nombre: "FOTOGRAFÍA DIGITAL"
    },
    {
        id: 1,
        nombre: "PRODUCCIÓN DE EVENTOS"
    },
    {
        id: 3,
        nombre: "INFOGRAFÍA"
    },
    {
        id: 4,
        nombre: "TALLER DE EMPRENDIMIENTO"
    },
    {
        id: 5,
        nombre: "CINE, TEATRO Y MODA"
    },
    {
        id: 6,
        nombre: "ECODISEÑO"
    },
    {
        id: 8,
        nombre: "VITRINISMO"
    }
];

export const PubMercSemI = [
    {
        id: 0,
        nombre: "TÉCNICAS DE EXPRESIÓN I"
    },
    {
        id: 1,
        nombre: "LÓGICA MATEMÁTICA"
    },
    {
        id: 3,
        nombre: "FUNDAMENTOS DE LA ECONOMÍA"
    },
    {
        id: 4,
        nombre: "LENGUA Y COMUNICACIÓN"
    },
    {
        id: 5,
        nombre: "COLOR"
    },
    {
        id: 6,
        nombre: "INTRODUCCIÓN A LA PUBLICIDAD"
    }
];

export const PubMercSemII = [
    {
        id: 0,
        nombre: "TÉCNICAS DE COMUNICACIÓN PUBLICITARIA"
    },
    {
        id: 1,
        nombre: "TÉCNICAS DE ESTUDIO E INVESTIGACIÓN"
    },
    {
        id: 3,
        nombre: "ESTADÍSTICAS I"
    },
    {
        id: 4,
        nombre: "INGLÉS"
    },
    {
        id: 5,
        nombre: "MEDIOS PUBLICITARIOS"
    },
    {
        id: 6,
        nombre: "RECURSOS GRÁFICOS"
    }
];

export const PubMercSemIII = [
    {
        id: 0,
        nombre: "ESTRATÉGIAS DE MEDIOS PUBLICITARIOS"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN I"
    },
    {
        id: 3,
        nombre: "SEMIÓTICA"
    },
    {
        id: 4,
        nombre: "ESTADÍSTICA II"
    },
    {
        id: 5,
        nombre: "TIPOGRAFÍA, ROTULACIÓN Y DIAGRAMACIÓN"
    },
    {
        id: 6,
        nombre: "MERCADOTÉCNIA I"
    },
    {
        id: 7,
        nombre: "SERVICIO COMUNITARIO (INDUCCIÓN)"
    }
];

export const PubMercSemIV = [
    {
        id: 0,
        nombre: "TEORÍA DE LA OPINIÓN Y DIRECCIÓN DE REUNIONES"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN II"
    },
    {
        id: 3,
        nombre: "SOCIOLOGÍA"
    },
    {
        id: 4,
        nombre: "PRESUPUESTO Y ADMINISTRACIÓN PUBLICITARIA"
    },
    {
        id: 5,
        nombre: "REDACCIÓN CREATIVA"
    },
    {
        id: 6,
        nombre: "MERCADOTÉCNIA II"
    },
    {
        id: 7,
        nombre: "SERVICIO COMUNITARIO (PROYECTO)"
    }
];

export const PubMercSemV = [
    {
        id: 0,
        nombre: "PSICOLOGÍA DE LA PUBLICIDAD"
    },
    {
        id: 1,
        nombre: "COMPUTACIÓN III"
    },
    {
        id: 3,
        nombre: "PROMOCIÓN Y VENTA DE PRODUCTOS"
    },
    {
        id: 4,
        nombre: "MERCADOTÉCNIA III"
    },
    {
        id: 5,
        nombre: "ELECTIVA"
    },
    {
        id: 6,
        nombre: "ELECTIVA"
    },
    {
        id: 7,
        nombre: "SEMINARIO DE METODOLOGÍA I"
    },
    {
        id: 8,
        nombre: "PASANTÍA"
    }
];

export const PubMercSemVI = [
    {
        id: 0,
        nombre: "ÉTICA, GERENCIA Y MARCO LEGAL"
    },
    {
        id: 1,
        nombre: "PORTAFOLIO DIGITAL"
    },
    {
        id: 3,
        nombre: "ELECTIVA"
    },
    {
        id: 4,
        nombre: "ELECTIVA"
    },
    {
        id: 5,
        nombre: "SEMINARIO DE METODOLOGÍA II"
    },
    {
        id: 6,
        nombre: "TRABAJO DE GRADO"
    }
];

export const PubMercElec = [
    {
        id: 0,
        nombre: "FOTOGRAFÍA DIGITAL"
    },
    {
        id: 1,
        nombre: "MARKETING DIGITAL"
    },
    {
        id: 3,
        nombre: "INFOGRAFÍA"
    },
    {
        id: 4,
        nombre: "TALLER DE EMPRENDIMIENTO"
    },
    {
        id: 5,
        nombre: "MEDIOS AUDIOVISUALES"
    },
    {
        id: 6,
        nombre: "PRODUCCIÓN DE EVENTOS"
    },
    {
        id: 8,
        nombre: "MEDICIÓN Y EFECTIVIDAD DE MEDIOS"
    }
];


// WEBPACK FOOTER //
// ./src/shared/PensumItems.jsx